import React from "react";
import { useState } from 'react'
import { Input, Button, Checkbox } from 'antd'
import { getViewPdfLink } from '../services/api'
import { DownloadOutlined } from '@ant-design/icons'

const ConfirmAndSign = ({showPdfLink, isPreview, onSubmit, isSubmitting}) => {
  const [showConsentError, setShowConsentError] = useState(false)
  const [showSignError, setShowSignError] = useState(false)
  const [isApproved, setIsApproved] = useState(false)
  const [approvedBy, setApprovedBy] = useState('')

  const handleConfirm = () => {
    if (!isApproved) {
      setShowConsentError(true)
    }

    const trimmed = approvedBy.trim()
    const isSigned = trimmed.length > 0
    if (!isSigned) {
      setShowSignError(true)
    }

    if (!isApproved || !isSigned) {
      return
    }

    onSubmit(trimmed)
  }

  return <div className="confirmation-section">
    
      <Checkbox
        checked={isApproved}
        onChange={x => {
          setIsApproved(x.target.checked)
          setShowConsentError(false)
          
        }}
      >
        I consent to electronic approval of the selected workareas
      </Checkbox>
      {showConsentError && <div className="validation-error">You must consent to electronic approval before confirming.</div>}
      <div className="signature-input">
        <div className="inner">
          <Input
            value={approvedBy}
            onChange={x => {
              setApprovedBy(x.target.value)
              setShowSignError(false)
            }}
            placeholder="Sign your name"
          />
          {showSignError && <div className="validation-error">You must sign your name before confirming.</div>}
          <div className="signature">{approvedBy}</div>
        </div>
      </div>
    

    <div>
      {showPdfLink && <Button
        icon={<DownloadOutlined />}
        type="link"
        href={getViewPdfLink(isPreview)}
        target="_blank"
        rel="noopener nofollower"
      >
        Download a PDF of this proposal
      </Button>}

      <Button
        type="primary"
        htmlType="submit"
        className="submit-btn"
        onClick={handleConfirm}
        loading={isSubmitting}
        disabled={isPreview}
        title={isPreview && 'Proposal cannot be approved in preview mode'}
      >
        Confirm
      </Button>
      </div>
  </div>
}

export default ConfirmAndSign
